// extracted by mini-css-extract-plugin
export default {"breadCrumbs":"Breadcrumbs_breadCrumbs__lNxqo"};